const SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/**
 * Format a byte count as a human-readable size string (e.g. `1.5 MB`).
 * Returns `null` for `null`/`undefined`/negative inputs so callers can
 * conditionally render the value.
 */
export function formatSize(bytes: number | null | undefined): string | null {
  if (bytes === null || bytes === undefined || bytes < 0) return null;
  if (bytes === 0) return '0 B';
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    SIZE_UNITS.length - 1,
  );
  const value = bytes / Math.pow(1024, exponent);
  const decimals = value >= 10 ? 0 : 1;
  const rounded = exponent === 0 ? value.toString() : value.toFixed(decimals);
  return `${rounded} ${SIZE_UNITS[exponent]}`;
}
